import { useConfigSettings } from '~/hooks/useConfigSettings';

export default function useIsIntelligemsEnabled() {
  const { data } = useConfigSettings(
    ({ shippingProtection }) => shippingProtection,
  );

  return !!data?.widgetConfig.shippingPlus.intelligems?.isEnabled;
}
